//GLOBAl LIBRARIES
